import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import 'rxjs/add/operator/toPromise';
declare const $: any;

@Component({
    selector: 'bsp-confirm',
    templateUrl: './confirm.component.html'
})

export class ConfirmComponent {
    @Input() public confirmParam;
    @Output() public callback: EventEmitter<any> = new EventEmitter(true);
    el: any;

    constructor(private translate: TranslateService) {
    }

    doAction(event) {
        $.magnificPopup.close();
        if (event === 'confirm') {
            this.callback.emit(this.confirmParam);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/confirm/confirm.component.ts